<!--
 * @Author: your name
 * @Date: 2020-07-22 16:51:23
 * @LastEditTime: 2020-10-10 14:21:18
 * @LastEditors: Please set LastEditors
 * @Description: 大题
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\question\question\big_question.vue
--> 
<template>
  <div class="big_question">
    <div class="topic">{{bigQuestion.description}}</div>
    <div class="concrete_question" v-for="(question,index) in bigQuestion.gkQuestions" :key="index">
      <template v-if="question.typeCode == 'M'">
        <compositeQuestion :isShowCorrectBtn="isShowCorrectBtn" :isShowAnswerArea="isShowAnswerArea" :selfAssessment="selfAssessment" :is-show-self-answer="isShowSelfAnswer" :question="question"></compositeQuestion>
      </template>
      <template v-else>
        <baseQuestion :isShowCorrectBtn="isShowCorrectBtn" :isShowAnswerArea="isShowAnswerArea" :selfAssessment="selfAssessment" :is-show-self-answer="isShowSelfAnswer" :question="question" :isDisable="isDisable"></baseQuestion>
      </template>  
    </div>
  </div>
</template>

<script>

import compositeQuestion from "@/components/paper/question/question/composite_question";
import baseQuestion from "@/components/paper/question/question/base_question"
export default {
  name: "bigQuestion",
  components: {
    compositeQuestion,
    baseQuestion
  },
  props: {
    bigQuestion: {
      type: Object,
      default: function () {
        return {};
      },
    },
    selfAssessment: {
      type: Boolean,
      default : false
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    isShowSelfAnswer:{
      type: Boolean,
      default: false
    },
    
    isShowCorrectBtn : {
      type : Boolean,
      default : true
    },
    isShowAnswerArea : {
      type : Boolean,
      default : true
    }
  },
  mounted(){
  }
};
</script>

<style lang="stylus" scoped>
.big_question {
  width: 1576px;
  position: relative;
  float: left;
  border-bottom: 30px #ffffff solid;
  padding-bottom: 15px;
  background-color: #ffffff;
  .topic {
    position: relative;
    width: 1573px;
    font-size: 32px;
    color: #585858;
    float: left;
    text-indent: 25px;
    background-color: #ffffff;
    word-wrap: break-word;
    border-bottom: 30px #ffffff solid;
  }

  .concrete_question {
  }
}
</style>